import { createAction } from 'redux-actions'
import axios from 'axios';

// 获得并查询所有任务信息
export const getTasksSucceeded = createAction('Tasks/GET_SUCCEEDED')
export const getTasksFailed = createAction('Tasks/GET_FAILED')

export function fetchGetTasks(params) {
  return dispatch => (
    axios.get('/api/job/getJobs', { params })
      .then(response => dispatch(getTasksSucceeded(response)))
      .catch(error => dispatch(getTasksFailed(error)))
  )
}

// 查看详情
export const gettaskDetailsRequested = createAction('taskDetails/GET_REQUESTED')
export const gettaskDetailsSucceeded = createAction('taskDetails/GET_SUCCEEDED')
export const gettaskDetailsFailed = createAction('taskDetails/GET_FAILED')

export function fetchGettaskDetails(params) {
  return dispatch => (
    axios.get('/api/job/getJobDetail', { params })
      .then(response => dispatch(gettaskDetailsSucceeded(response)))
      .catch(error => dispatch(gettaskDetailsFailed(error)))
  )
}



// WEBPACK FOOTER //
// ./actions/queryTasks.js